// @flow

import gql from 'graphql-tag';

import { useMutation } from '@apollo/react-hooks';

type Input = {
  accountId: ?number,
};

type Output = {
  error: ?string,
  hasSaved: boolean,
  isLoading: boolean,
  onEnableAutoUpgrade: () => void,
};

const enableAutoUpgradeMutation = gql`
  mutation enableAutoUpgrade($accountId: Int!, $input: AccountInput!) {
    updateAccount(id: $accountId, input: $input) {
      id
    }
  }
`;

function useAutoUpgrade({ accountId }: Input): Output {
  const [enableAutoUpgrade, results] = useMutation(enableAutoUpgradeMutation);

  function onEnableAutoUpgrade() {
    enableAutoUpgrade({
      variables: {
        accountId,
        input: {
          companiesTrialAutoUpgrade: true,
        },
      },
    });
  }

  return {
    error: results.error,
    hasSaved: results.called,
    isLoading: results.loading,
    onEnableAutoUpgrade,
  };
}

export default useAutoUpgrade;
